import styles from './EmptyPage.module.css';
import messages from './EmptyPage.messages';

const EmptyPage = ({ message }: { message?: string }): JSX.Element => (
  <div className={styles.noItems}>{message ? message : messages.noItemsToDisplay}</div>
);

export default EmptyPage;
